import api from '../../api'

export const periodService = {
    // Get all periods
    getPeriods: async () => {
        try {
            const response = await api.get('/periods/teacher')                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
            return response.data
        } catch (error) {
            console.error('Error fetching periods:', error)
            throw error
        }
    },
    // Get period details
    getPeriodDetails: async (periodId) => {
        try {
            const response = await api.get(`/periods/${periodId}`)
            return response.data
        } catch (error) {
            console.error('Error fetching period details:', error)
            throw error
        }
    },

    // Get reports
    getPeriodReports: async () => {
        try {
            const response = await api.get('/periods/reports')
            return response.data
        } catch (error) {
            console.error('Error fetching reports:', error)
            throw error
        }
    },

    // Create new period
    createPeriod: async (periodData) => {
        try {
            const response = await api.post('/periods', periodData)
            return response.data
        } catch (error) {
            console.error('Error creating period:', error)
            throw error
        }
    },

    // Update period
    updatePeriod: async (periodId, periodData) => {
        try {
            const response = await api.put(`/periods/${periodId}`, periodData)
            return response.data
        } catch (error) {
            console.error('Error updating period:', error)
            throw error
        }
    },

    // Finalize period
    finalizePeriod: async (periodId) => {
        try {
            const response = await api.get(`/periods/${periodId}/finalize`)
            //Return response only to check status
            return response
        } catch (error) {
            console.error('Error finalizing period:', error)
            throw error
        }
    },

    // Delete period
    deletePeriod: async (periodId) => {
        try {
            const response = await api.delete(`/periods/${periodId}`)
            return response.data
        } catch (error) {
            console.error('Error deleting period:', error)
            throw error
        }
    },

    // Get periods for a course
    getCoursePeriods: async (courseId) => {
        try {
            const response = await api.get(`/courses/${courseId}/periods`)
            return response.data
        } catch (error) {
            console.error('Error fetching course periods:', error)
            throw error
        }
    },

    // Get default periods
    getDefaultPeriods: async () => {
        try {
            const response = await api.get('/periods/defaults')
            return response.data
        } catch (error) {
            console.error('Error fetching default periods:', error)
            throw error
        }
    }
}
